import type React from 'react';
import { useTranslation } from 'react-i18next';
import { getNodeTestProps } from '@/utils';
import { DatePickerField } from '@/components/datePickerField';

type TransactionsDateBarProps = {
    value: string;
    onChange: (value: string) => void;
};

/**
 * The page's day selector (render-only). A single date picker, defaulting to
 * today via the page hook; changing it re-fetches the list. Constrained to a
 * content width so it doesn't stretch across the page.
 */
export const TransactionsDateBar: React.FC<TransactionsDateBarProps> = ({
    value,
    onChange,
}) => {
    const { t } = useTranslation('pages');

    return (
        <div
            className="w-full max-w-60"
            {...getNodeTestProps('transactions-date-bar')}
        >
            <DatePickerField
                id="transactions-date"
                label={t('transactions.dateLabel')}
                name="transactions-date"
                onChange={onChange}
                outputFormat="YYYY-MM-DD"
                value={value}
            />
        </div>
    );
};
